import { render } from "./MyCertView.vue?vue&type=template&id=3bd0501c&scoped=true"
import script from "./MyCertView.vue?vue&type=script&lang=js"
export * from "./MyCertView.vue?vue&type=script&lang=js"

import "./MyCertView.vue?vue&type=style&index=0&id=3bd0501c&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd0501c"]])

export default __exports__